import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './badge.scss';

// Components
import ImageAsset from '../image-asset/image-asset';

/**
 *
 * @param badgeId {string} The id that will ne given to the occurrence, to position it individually
 * @param iconName {string} One of the possible icons of ImageAsset component
 * @param assetTitle {string} The "title" on hover
 * @param visibleText {string} The visible text
 * @param imageClassName {string} An additional class put on the ImageAsset Component if needed
 * @returns {*}
 * @constructor
 */
function Badge({ badgeId, iconName, assetTitle, visibleText, imageClassName }) {
    return (
        <div className="badge" id={badgeId}>
            <ImageAsset parentClass={imageClassName} type={iconName} parentTitle={assetTitle} />
            {visibleText ? <span className="badge__text">{visibleText}</span> : ''}
        </div>
    );
}

/**
 * Define the default values for the properties being used
 */
Badge.defaultProps = {
    iconName: 'newIcon',
    imageClassName: null
};

/**
 * Define the type of properties that can be set on this component
 */
Badge.propTypes = {
    badgeId: PropTypes.string,
    iconName: PropTypes.string,
    assetTitle: PropTypes.string,
    visibleText: PropTypes.string,
    imageClassName: PropTypes.string
};

export default Badge;



// WEBPACK FOOTER //
// ./components/badge/badge.js